import { useEffect } from 'preact/hooks'

export function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

export const DEFAULT_IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function getLowQualityPlaceholder(imageUrl) {
  if (!imageUrl) return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII='
  return `${imageUrl}&width=5`
}

function getImgProps({ src, alt, sizes, eager, width, height, widths }) {
  if (eager) {
    return {
      src,
      srcset: generateSrcSet(src, widths),
      sizes,
      loading: 'eager',
      fetchpriority: 'high',
      width,
      height,
      alt
    }
  }
  return {
    src: getLowQualityPlaceholder(src),
    'data-src': src,
    'data-srcset': generateSrcSet(src, widths),
    'data-sizes': sizes,
    width,
    height,
    alt
  }
}

export function ResultImage({
  result,
  children,
  eager = false,
  sizes = '50vw',
  widths = DEFAULT_IMAGE_WIDTHS,
  width = 400,
  height = 500
}) {
  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [result?.images, result?.image])

  return (
    <div className="relative size-full overflow-hidden border-0">
      {result?.images?.length >= 2 ? (
        <>
          <img
            key={result.images[1].src}
            className="lazy absolute inset-0 object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)]"
            {...getImgProps({
              src: result.images[1].src,
              alt: result.images[1].alt || result.title || 'Product image 1',
              sizes,
              eager: false,
              width,
              height,
              widths
            })}
          />
          <img
            key={result.images[0].src}
            className={`${eager ? '' : 'lazy '}absolute inset-0 object-cover size-full transition-all bg-[--section-bg-colour,theme(colors.brand.white)] group-hover/card:opacity-0`}
            {...getImgProps({
              src: result.images[0].src,
              alt: result.images[0].alt || result.title || 'Product image 2',
              sizes,
              eager,
              width,
              height,
              widths
            })}
          />
        </>
      ) : result.image ? (
        <img
          key={result.image}
          className={`${eager ? '' : 'lazy '}object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)]`}
          {...getImgProps({
            src: result.image,
            alt: result.image.alt || result.title || 'Product image',
            sizes,
            eager,
            width,
            height,
            widths
          })}
        />
      ) : null}
      {children}
    </div>
  )
}
